import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * ValidationGlobalFieldProcessor формирует и валидирует поля виджета
 */
export class ValidationGlobalFieldProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const fieldValues: { [T in string]: number } = {};

    additionalServiceState.FieldsToDisplay.map((f) => {
      let fieldValue = f.value ?? 0;

      const foundOption = optionsState.FieldOptions[f.code]?.find(
        (option) => option.value === fieldValue
      );

      if (!foundOption && !['switch', 'hidden', 'number'].includes(f.type)) {
        fieldValue = 0;
      }

      fieldValues[f.code] = fieldValue;
    });

    const isEmptyFieldsExist = Object.values(additionalServiceState.FieldsToDisplay).every(
      (field) => {
        if (['switch', 'hidden', 'number'].includes(field.type)) {
          return true;
        }

        if (fieldValues[field.code] <= 0) {
          return false;
        }
      }
    );

    return {
      isValid: !isEmptyFieldsExist,
      additionalServiceState: {
        ...additionalServiceState,
        FieldValues: fieldValues,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
